import { connect } from 'react-redux';
import componentSelector from '../../selectors/component';
import { toggleModal, enquire, setSubmitted } from './actions';
import EnquireModal from './EnquireModal';
import { COMPONENT_NAME } from './constants';

function mapStateToProps(state) {
  return {
    modal: componentSelector(COMPONENT_NAME)(state),
  };
}

export default connect(
  mapStateToProps,
  { toggleModal, enquire, setSubmitted },
)(EnquireModal);



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/components/EnquireModal/index.js